module.exports = __webpack_public_path__ + "6NWsYel66POcs10XV/icon_info.svg";